<template>
  <ul
    :class="[
      props.isRequired ? 'modulesBoxUlRequired' : 'modulesBoxUlOptional',
    ]"
  >
    <li
      v-for="(item, i) in props.list"
      :key="item.data.moduleName + i"
      :class="[
        item.data.select ? 'isSelected' : '',
        isItemRequired(item) ? 'isRequiredItem' : '',
      ]"
      @click="changeSelect(item)"
    >
      <span :class="['icon', item.data.select ? 'isSelected' : '']" />
      <span class="name" :title="item.data.moduleName">{{
        item.data.moduleName
      }}</span>
      <sup v-if="item?.data?.moduleLabel">{{ item?.data?.moduleLabel }}</sup>
    </li>
  </ul>

  <!-- <ul class="modulesBoxUlRequired">
              <li
                v-for="(item, i) in state.modulesRequired"
                :key="item.name + i"
                :class="[item.isSelected ? 'isSelected' : '']"
              >
                <span :class="['icon', item.isSelected ? 'isSelected' : '']" />
                <span class="name">{{ item.name }}</span>
              </li>
            </ul> -->
  <!-- <ul class="modulesBoxUlOptional">
              <li
                v-for="(item, i) in state.modulesOptional"
                :key="item.name + i"
                :class="[item.isSelected ? 'isSelected' : '']"
                @click="item.isSelected = !item.isSelected"
              >
                <span :class="['icon', item.isSelected ? 'isSelected' : '']" />
                <span class="name">{{ item.name }}</span>
              </li>
            </ul> -->
</template>

<script setup>
const props = defineProps({
  list: {
    type: Array,
    requeired: true,
    default: () => [],
  },
  isRequired: {
    type: Boolean,
    requeired: false,
    default: false,
  },
});

const emit = defineEmits(["onChange"]);

const isItemRequired = (item) => {
  return !!item?.data?.required;
};

const changeSelect = (item) => {
  if (isItemRequired(item)) return;

  item.data.select = !item.data.select;
  emit("onChange");
};
</script>

<style lang="less" scoped>
li {
  height: 70px;
  background: #444444;
  border-radius: 10px;
  padding: 0 20px;
  margin-top: 12px;
  cursor: pointer;
  .flex(row,flex-start,center);
  .one-line-ellipsis();

  span.icon {
    display: inline-block;
    background-image: url("@/assets/imgs/product/notSelected.png");
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;
    min-width: 20px;
    .wh(20px,20px);
  }
  span.icon.isSelected {
    background-image: url("@/assets/imgs/product/selected.png");
  }
  span.name {
    .fcf(17,#fff,600);
    margin-left: 22px;
    .one-line-ellipsis();
  }
  sup {
    color: #fff;
    font-size: 12px;
  }
}
li.isSelected {
  background: #666666;
}
li.isRequiredItem {
  cursor: not-allowed;

  span.icon {
    cursor: not-allowed;
  }
}

.modulesBoxUlRequired {
  display: flex;
  flex-direction: column;
}

.modulesBoxUlOptional {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 12px;
}

@media (max-width: 1024px) {
  li {
    span.name {
      font-size: 14px;
    }
  }
}
</style>
